import { jsx as c } from "react/jsx-runtime";
import { useMemo as f } from "react";
import { configContext as s } from "../hooks/use-config.js";
const a = "sports";
function d(o) {
  const e = s.Provider, i = f(() => {
    var r;
    const n = Array.isArray((r = o.config) == null ? void 0 : r.pages) ? o.config.pages.some((t) => t.id === a) : !1;
    return {
      ...o.config,
      features: {
        hasSportsPage: n
      }
    };
  }, [o.config]);
  return /* @__PURE__ */ c(e, { value: i, children: o.children });
}
export {
  d as ConfigProvider
};
